<template>
    <div id="calendar" class="main padding-top50">
        <div class="container-fluid">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>Kalender</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p> En kalender er et nyttig verktøy for å markere viktige datoer og hendelser. &laquo;BeNet&raquo; ønsker å tilby 
                            dette til sine brukere for å gjøre det enklere å holde oversikt på frister og lignende.
                            I tillegg vil det redusere antall e-post angående spørsmål rundt dette.
                            Samtidig ble ikke kalender ansett som en kritisk funksjonalitet for at systemet skal fungere, og må derfor vente til neste iterasjon. 
                            Nedenfor er en illustrasjon av tenkt kalender. </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <img src="../assets/images/Kalender_benet.png" class="calendarImg" alt="Illustrasjon av kalenderen">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Calendar"
}
</script>
